import { render } from "./LogoContact.vue?vue&type=template&id=a167af84"
import script from "./LogoContact.vue?vue&type=script&lang=js"
export * from "./LogoContact.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__